import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import fastClick from 'fastclick'
import VueWechatTitle from 'vue-wechat-title'
import 'babel-polyfill'
import Navigation from 'vue-navigation'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import { Swipe, SwipeItem } from 'mint-ui'
import 'mint-ui/lib/style.css'
import md5 from 'js-md5'
import 'weui'

Vue.config.productionTip = false

// 处理fastclick导致的输入框点击无响应的问题
fastClick.prototype.focus = function(targetElement) {
  var length
  if (
    /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent) &&
    targetElement.setSelectionRange &&
    targetElement.type.indexOf('date') !== 0 &&
    targetElement.type !== 'time' &&
    targetElement.type !== 'month' &&
    targetElement.type !== 'email'
  ) {
    length = targetElement.value.length
    targetElement.setSelectionRange(length, length)
    /* 修复bug ios 11.3不弹出键盘，这里加上聚焦代码，让其强制聚焦弹出键盘 */
    targetElement.focus()
  } else {
    targetElement.focus()
  }
}

import './assets/css/reset.css'
import './assets/css/border.css'
import 'swiper/dist/css/swiper.css'

Vue.use(VueWechatTitle)
Vue.use(Navigation, { router, store })
Vue.use(VueAwesomeSwiper)

fastClick.attach(document.body)
Vue.prototype.$md5 = md5

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
}).$mount('#app')
